import {
    Cell,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
} from "recharts";

import styles from "./DonutChart.module.css";


export const COLORS = [
    "#2563eb",
    "#22c55e",
    "#f59e0b",
    "#8b5cf6",
    "#ef476f",
];


export const getItemColor = (key, index = 0) => {

    const colorMap = {
        fuel: COLORS[0],
        service: COLORS[1],
        repair: COLORS[2],
        bill: COLORS[3],
        other: COLORS[4],
    };

    return (
        colorMap[key] ||
        COLORS[index % COLORS.length]
    );
};


const renderLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
    payload,
}) => {

    const RADIAN = Math.PI / 180;

    const radius =
        innerRadius +
        (outerRadius - innerRadius) * 0.55;

    const x =
        cx +
        radius *
            Math.cos(
                -midAngle * RADIAN
            );

    const y =
        cy +
        radius *
            Math.sin(
                -midAngle * RADIAN
            );

    const label =
        payload?.label ||
        payload?.name ||
        "";

    const percentage =
        payload?.percentage ??
        Math.round(percent * 100);

    return (
        <text
            x={x}
            y={y}
            textAnchor="middle"
            dominantBaseline="central"
            fill="#ffffff"
            style={{
                fontSize: "0.8rem",
                fontWeight: 700,
                pointerEvents: "none",
            }}
        >
            <tspan
                x={x}
                dy="-0.55em"
            >
                {label}
            </tspan>

            <tspan
                x={x}
                dy="1.35em"
                style={{
                    fontSize: "0.85rem",
                    fontWeight: 800,
                }}
            >
                {percentage}%
            </tspan>
        </text>
    );
};


const DonutChart = ({
    data = [],
}) => {

    /*
     * Backend ممکن است مستقیماً آرایه بدهد
     * یا آبجکت costBreakdown را بدهد.
     */
    const items = Array.isArray(data)
        ? data
        : data?.items || [];


    /*
     * فقط آیتم‌هایی که مبلغشان بیشتر از صفر است
     * در خود نمودار نمایش داده می‌شوند.
     *
     * items اصلی دست‌نخورده می‌ماند تا Legend
     * بتواند آیتم‌های صفر را هم نمایش دهد.
     */
    const chartData = items.filter(
        (item) => Number(item?.percentage) > 0
    );


    if (!chartData.length) {
        return null;
    }


    return (

        <div
            className={styles.chartWrapper}
        >

            <div
                className={styles.chart}
            >

                <ResponsiveContainer
                    width="100%"
                    height="100%"
                >

                    <PieChart>

                        <Pie
                            data={chartData}
                            dataKey="amount"
                            nameKey="label"
                            innerRadius="48%"
                            outerRadius="88%"
                            paddingAngle={2}
                            stroke="#ffffff"
                            strokeWidth={2}
                            labelLine={false}
                            label={renderLabel}
                        >

                            {
                                chartData.map(
                                    (item, index) => (
                                        <Cell
                                            key={
                                                item.key ??
                                                index
                                            }
                                            fill={
                                                getItemColor(
                                                    item.key,
                                                    index
                                                )
                                            }
                                        />
                                    )
                                )
                            }

                        </Pie>

                        <Tooltip />

                    </PieChart>

                </ResponsiveContainer>


                <div
                    className={
                        styles.centerLabel
                    }
                >

                    <strong>
                        کل هزینه‌ها
                    </strong>

                </div>

            </div>

        </div>

    );
};


export default DonutChart;
